import React from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { headingStyle } from '../../../../play-core/styles/heading-style';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { jsx as _jsx } from "react/jsx-runtime";
export const PageTitle = ({
  title
}) => /*#__PURE__*/_jsx(Heading, {
  children: title
});
const Heading = styled.h1.withConfig({
  displayName: "PageTitle__Heading",
  componentId: "sc-1jppv2k-0"
})(["color:", ";margin-bottom:4px;margin-top:32px;line-height:36px;", "{line-height:40px;margin-bottom:20px;}", "{line-height:48px;margin-bottom:24px;margin-top:70px;}", ";:first-letter{text-transform:capitalize;}"], Colors.WHITE, Viewports.for('large'), Viewports.for('xLargeUp'), headingStyle);